import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AppState} from './app.reducer';

export const selectAppState = createFeatureSelector<AppState>('app');

export const isAuthenticated = createSelector(
    selectAppState,
    (state: AppState) => state.user != null
);

export const selectUser = createSelector(
    selectAppState,
    (state: AppState) => state.user
);

export const isConnected = createSelector(
    selectAppState,
    (state: AppState) => state.connected
);

export const selectNotificationToken = createSelector(
    selectAppState,
    (state: AppState) => state.notificationToken
);
